import React from 'react'
import classes from "./style.module.scss";
import { Icons } from '../../../../assets';
import CounterComponent from '../../../../component/CounterComponent';
import { useNavigate } from 'react-router-dom';


const AnalyticsData = (props) => {
    const { analyticsData } = props

    const navigate = useNavigate();

    const handleClick = (metric) => {
      navigate(`/admin/appAnalytics?metric=${metric}`);
    }

    return (
        <div className={`eventWrapper mt-4`}>
            <div className={`component-title flex items-center`}>
                <div className='label'>Analytics Data</div>
                <div className='vector'></div>
            </div>
            <div className={`eventWrapper ${classes.analyticsCardWrapper}`}>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%] cursor-pointer`} onClick={() => handleClick("failedQRScans")}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.failedQRScansCount} /></div>
                        <div className={`${classes.cardDescription}`}>Failed QR Scan Count</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalQR} alt='Total QR' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%] cursor-pointer`} onClick={() => handleClick("firstTimeQRScanned")}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.firstQrScanned} /></div>
                        <div className={`${classes.cardDescription}`}>First QR Scanned</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalQR} alt='Total QR' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%] cursor-pointer`} onClick={() => handleClick("repeatedQRScanned")}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.repeatScannedUsers} /></div>
                        <div className={`${classes.cardDescription}`}>Repeated Scanned Users</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalUser} alt='Total Users' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%] cursor-pointer`} onClick={() => handleClick("rewardRedeemedFirstTime")}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.rewardRedeemedFirstTime} /></div>
                        <div className={`${classes.cardDescription}`}>Reward Redeemed First Time</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalFeedback} alt='Total Feedback' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.scanToRedeemRatio} /></div>
                        <div className={`${classes.cardDescription}`}>Scanned to Redeemed Ratio</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.openRedeemRewards} alt='Total openRedeemRewards' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.totalScanedPoints} /></div>
                        <div className={`${classes.cardDescription}`}>Total Scanned Points</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalQR} alt='Total QR' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%] cursor-pointer`} onClick={() => handleClick("totalQRScansByActiveusers")}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.totalScans} /></div>
                        <div className={`${classes.cardDescription}`}>Total Scans by Active Users</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalQR} alt='Total QR' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.totalMechanicPoints} /></div>
                        <div className={`${classes.cardDescription}`}>Mechanic Points Generated</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalIncompleteMechanics} alt='Mechanic Points Generated' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.totalRetailerPoints} /></div>
                        <div className={`${classes.cardDescription}`}>Retailer Points Generated</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalInCompleteRetailers} alt='Retailer Points Generated' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.totalMechanicScannedPoints} /></div>
                        <div className={`${classes.cardDescription}`}>Total Mechanic Scanned Points</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalIncompleteMechanics} alt='Total Mechanic Scanned Points' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.totalRetailerScannedPoints} /></div>
                        <div className={`${classes.cardDescription}`}>Total Retailer Scanned Points</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalInCompleteRetailers} alt='Total Retailer Scanned Points' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%] cursor-pointer`} onClick={() => handleClick("totalQRScanByDeletedUsers")}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.totalScansByDeletedUsers} /></div>
                        <div className={`${classes.cardDescription}`}>Total Scans by Deleted Users</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalQR} alt='Total Scans by Deleted Users' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.totalScanedPointsByDeletedUser} /></div>
                        <div className={`${classes.cardDescription}`}>Total Scanned Points by Deleted Users</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalQR} alt='Total Scanned Points by Deleted Users' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.totalMechanicScannedPointsByDeletedUser} /></div>
                        <div className={`${classes.cardDescription}`}>Total Mechanic Scanned Points by Deleted Users</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalIncompleteMechanics} alt='Total Mechanic Scanned Points by Deleted Users' />
                    </div>
                </div>
                <div className={`${classes.analyticsCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={analyticsData?.totalRetailerScannedPointsByDeletedUser} /></div>
                        <div className={`${classes.cardDescription}`}>Total Retailer Scanned Points by Deleted Users</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalInCompleteRetailers} alt='Total Retailer Scanned Points by Deleted Users' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AnalyticsData